class VaultsNew {
  title: string;

  coverSignedId?: string;

  contributors: ContributorType[];

  subscriptionType: string;

  note: string;

  constructor(params?: VaultNewRequestType) {
    this.title = params?.title || '';
    this.subscriptionType = params?.subscriptionType || '';
    this.coverSignedId = params?.coverSignedId;
    this.contributors = params?.contributors || [];
    this.note = params?.note || '';
  }
}

export { VaultsNew };
